// src/components/MarketingAuthRedirect.tsx
//
// D-RC-3 Path A implementation (per slice-E §"Architecture target" and
// docs/marketing-split/01-decisions-needed.md §D-RC-3 in perch-mobile).
//
// Behavior: on first render, check whether a (non-expired) Supabase
// session exists in localStorage from the app side. If yes,
// full-page-navigate to /customer-portal — the app bundle loads on
// the same origin (Phase A), reads the same localStorage session,
// and its own NavigationControl re-routes admins to /admin from
// there. If no session, no-op.
//
// Why a full-page nav (not SPA navigate): /customer-portal lives in
// the perch-mobile bundle, not perch-marketing. Under Phase A,
// CloudFront routes /customer-portal to the app S3 bucket; the app
// bundle then hydrates from the shared localStorage session.
//
// Why no admin RPC here: NavigationControl.tsx:124-134 in perch-mobile
// already re-routes admins from /customer-portal → /admin. Doing the
// is_admin call here too is a wasted round-trip (D-RC-3 final
// "Implementation note" paragraph).
//
// EXT-2 closure note: hasMarketingSession() reads localStorage
// directly and does NOT instantiate a Supabase auth client. That
// keeps marketing free of the auth subsystem (no refresh-token
// timer, no tab-sync `storage` listener) — see the docstring on
// hasMarketingSession in src/lib/supabase-marketing.ts. As a
// consequence, this file no longer touches `supabase.*` at all,
// so the EXT-4 ESLint wall can apply uniformly with no exemption
// needed for this file.

import { useEffect } from "react";
import { hasMarketingSession } from "@/lib/supabase-marketing";

export function MarketingAuthRedirect() {
  useEffect(() => {
    if (hasMarketingSession()) {
      window.location.href = "/customer-portal";
    }
  }, []);

  return null;
}
